import { gql } from '@apollo/client';

const GET_CURRENT_PERSON = gql`
  query getPerson {
    currentUser {
      id
      roles
    }
  }
`;

export default GET_CURRENT_PERSON;
